let util = (function () {

  /**
   * 쿼리스트링 파라미터 반환
   */
  function getParams(search) {
    let queryStr = search.substring(1);
    let params = {}
    try {
      params = JSON.parse('{"' + decodeURI(queryStr).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
    } catch(ignored) {}
    return params;
  }


  /**
   * 자바스크립트 오브젝트를 URLSearchParams 객체로 변환
   * @param {object} obj 
   */
  function convertToURLParams(obj) {
    let params  = new URLSearchParams();
    for (let key in obj) {
      params.append(key, obj[key])
    }

    return params;
  }


  /**
   * 객체의 속성키를 변환 : CamelCase -> UnderscoreCase
   * @param {object} obj 
   */
  function convertAttrToUnderscore(obj) {
    let result = {};
    for (let key in obj) {
      result[key.split(/(?=[A-Z])/).join('_').toLowerCase()] = obj[key];
    }
    return result;
  }


  /**
   * 파일 사이즈 포맷팅
   */
  function formatFileSize(size) {
    if (!size || isNaN(size)) {
      return '0B';
    }
    
    let rankStr = ['B', 'KB', 'MB', 'GB'];
    let rank = 0;
    let number = Number(size);
    
    for (let i = 0; i < rankStr.length; i++) {
      if (number < 1000) {
        break;
      }
      
      number = number/1024;
      rank++;
    }
    
    let digit = 2 - Math.floor(Math.log10(number));
    if (rank === 0) {
      digit = 0;
    }
    return number.toFixed(digit)+rankStr[rank];
  }


  /**
   * html 태그 제거
   * @param {string} str 
   */
  function removeTags(str) {
    if (!str) {
      str = '';
    } else {
      str = str.toString();
    }

    return str.replace(/(<([^>]+)>)/ig, '');
  } 



  /**
   * 에니메이션 없이 스크롤 탑으로 이동
   */
  function scrollToTop() {
    document.documentElement.style.scrollBehavior = 'auto';
    setTimeout(() => {
      window.scrollTo(0,0);
      document.documentElement.style.scrollBehavior = '';
    }, 0);
  }


  /**
   * 파일 다운로드
   * @param {string} url 파일 다운로드 경로
   * @param {string} filename 파일명
   */
  function download(url, filename) {
    
    fetch(url).then(async t => {
      const b = await t.blob();
      let a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.setAttribute("download", filename);
      a.click();
    });
  }

  return {
    getParams: getParams,     //쿼리스트링 파라미터 반환
    convertToURLParams: convertToURLParams,   //자바스크립트 오브젝트를 URLSearchParams 객체로 변환
    convertAttrToUnderscore: convertAttrToUnderscore, //객체의 속성키를 변환 : CamelCase -> UnderscoreCase
    formatFileSize: formatFileSize,     // 파일 사이즈 포맷팅
    removeTags: removeTags,     //html 태그 제거
    scrollToTop: scrollToTop,   //에니메이션 없이 스크롤 탑으로 이동
    download: download,       //파일 다운로드
  }
})();

export default util;